import React, { useMemo } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Date range filter with presets.
 * Value: { from: "YYYY-MM-DD" | "", to: "YYYY-MM-DD" | "" }
 */
export default function DateRangeFilter({ value, onChange }) {
  const setPreset = (preset) => {
    const now = new Date();
    const y = now.getFullYear();
    const m = now.getMonth();
    const fmt = (d) => d.toISOString().slice(0, 10);
    let from = "", to = fmt(now);
    if (preset === "today") from = fmt(now);
    else if (preset === "7d") from = fmt(new Date(now.getTime() - 6 * 86400000));
    else if (preset === "30d") from = fmt(new Date(now.getTime() - 29 * 86400000));
    else if (preset === "month") { from = fmt(new Date(y, m, 1)); to = fmt(new Date(y, m + 1, 0)); }
    else if (preset === "lastmonth") { from = fmt(new Date(y, m - 1, 1)); to = fmt(new Date(y, m, 0)); }
    else if (preset === "year") { from = fmt(new Date(y, 0, 1)); to = fmt(new Date(y, 11, 31)); }
    else if (preset === "all") { from = ""; to = ""; }
    onChange({ from, to });
  };

  const presets = [
    { k: "today", label: "Hari Ini" },
    { k: "7d", label: "7 Hari" },
    { k: "30d", label: "30 Hari" },
    { k: "month", label: "Bulan Ini" },
    { k: "lastmonth", label: "Bulan Lalu" },
    { k: "year", label: "Tahun Ini" },
    { k: "all", label: "Semua" },
  ];

  return (
    <div className="flex flex-wrap items-end gap-3 border border-[var(--hotto-border)] rounded-md bg-white p-4">
      <div>
        <Label className="text-xs">Dari</Label>
        <Input type="date" value={value.from} onChange={(e)=>onChange({...value, from:e.target.value})} className="h-9 w-40" data-testid="filter-from"/>
      </div>
      <div>
        <Label className="text-xs">Sampai</Label>
        <Input type="date" value={value.to} onChange={(e)=>onChange({...value, to:e.target.value})} className="h-9 w-40" data-testid="filter-to"/>
      </div>
      <div className="flex flex-wrap gap-1 ml-auto">
        {presets.map((p) => (
          <Button key={p.k} size="sm" variant="outline" onClick={()=>setPreset(p.k)} data-testid={`preset-${p.k}`} className="h-8 text-xs">
            {p.label}
          </Button>
        ))}
      </div>
    </div>
  );
}

/** Helper: filter array by date range on `date` field (ISO). */
export function useDateFilter(items, range) {
  return useMemo(() => {
    if (!range.from && !range.to) return items;
    return items.filter((it) => {
      const d = (it.date || "").slice(0, 10);
      if (range.from && d < range.from) return false;
      if (range.to && d > range.to) return false;
      return true;
    });
  }, [items, range]);
}
